module.exports = __webpack_public_path__ + "img/m-mao.36c4cda9.png";